import JSONbig from 'json-bigint';

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export function convertToBoolean(value: number, trueValue: number, falseValue: number) : boolean | undefined {
    switch(value ?? -1) {
        case falseValue:
            return false;
        case trueValue:
            return true;
        default:
            return undefined;
    }
}

export function convertFromBoolean(value: boolean | undefined, trueValue: number = 0, falseValue: number = 1) : number {
    return value === undefined ? -1 : value ? trueValue: falseValue;
}

export const formatJsonData = (data: string | null): string => {
    if (!data) return '';
    try {
        // Пытаемся распарсить JSON
        let parsed = JSONbigNative.parse(data);
        // Если результат - строка, пытаемся распарсить её снова (для случая двойного экранирования)
        if (typeof parsed === 'string') {
            try {
                parsed = JSONbigNative.parse(parsed);
            } catch {
                // Если не получилось, оставляем как есть
            }
        }
        return JSONbig.stringify(parsed, null, 2);
    } catch {
        // Если не удалось распарсить, возвращаем исходные данные
        return data;
    }
}